import { REEBELO_TZ_NAME, ReebeloStoreT } from './types';

export const getCurrentTimeZoneByStore = (
  store: ReebeloStoreT,
  date?: string,
) => {
  // Get current date and time
  const now = date ? new Date(date) : new Date();
  // Get the local timezone offset in minutes
  const timezoneOffsetMinutes = now.getTimezoneOffset();
  // Convert the offset to hours
  const timezoneOffsetHours = -timezoneOffsetMinutes / 60;

  switch (store) {
    case 'reebelo-nz': {
      // Pacific/Auckland
      if (timezoneOffsetHours === 13) {
        return REEBELO_TZ_NAME[store];
      }

      return 'Pacific/Fiji';
    }

    case 'reebelo-au': {
      // Australia/Melbourne
      if (timezoneOffsetHours === 11) {
        return REEBELO_TZ_NAME[store];
      }

      return 'Australia/Brisbane';
    }

    case 'reebelo-us': {
      // 'America/Yellowknife'
      if (timezoneOffsetHours === 6) {
        return REEBELO_TZ_NAME[store];
      }

      return 'America/Los_Angeles';
    }

    default:
      return REEBELO_TZ_NAME[store];
  }
};
